import { render, staticRenderFns } from "./MypageOneTimePassConfirmPage.vue?vue&type=template&id=27731ca7"
import script from "./MypageOneTimePassConfirmPage.vue?vue&type=script&lang=ts"
export * from "./MypageOneTimePassConfirmPage.vue?vue&type=script&lang=ts"
import style0 from "./MypageOneTimePassConfirmPage.vue?vue&type=style&index=0&id=27731ca7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports